import { useT } from '../lib/i18n';

/** Small status tags for an appointment (instead of emoji): new client, booked online, a warning, no-show. */
export function AppointmentTags({ a, className = '' }: { a: { newClient?: boolean; alert?: boolean | string | null; source?: string; status?: string }; className?: string }) {
  const t = useT();
  return (
    <span className={`flex flex-wrap items-center gap-1 ${className}`}>
      {a.status === 'no_show' && <span className="tag bg-danger-soft text-danger">{t('status.no_show')}</span>}
      {a.alert && <span className="tag bg-warning-soft text-warning">{t('cal.alert')}</span>}
      {a.newClient && <span className="tag bg-accent-soft text-accent-strong">{t('tag.new')}</span>}
      {a.source === 'online' && <span className="tag bg-subtle text-muted">{t('tag.online')}</span>}
    </span>
  );
}
